import styled from 'styled-components'

export const FactsComponent = styled.div`
  margin-top: 10px;
  margin-bottom: 10px;

  @media ${ (props) => props.theme.breakpoints.devices.min.sm }, print {
    margin: 0 15px;
  }

  .content-container {
    display: flex;
    flex-wrap: wrap;
  }

  .table-content {
    flex-basis: 100%;
  }

  .contact-content {
    flex-basis: 100%;
    margin-bottom: 10px;

    @media ${ (props) => props.theme.breakpoints.devices.min.sm }, print {
      flex-basis: 50%;

      &:nth-child(even) {
        padding-right: 10px;
      }

      &:nth-child(odd) {
        padding-left: 10px;
      }

      margin-bottom: 20px;
    }
  }

  .contact-icon {
    color: ${ (props) => props.theme.colors['icon-grau1'] };
    margin-right: 20px;
  }

  .image-container {
    width: 80px;
    border-radius: 50%;
    overflow: hidden;
    margin-bottom: 10px;

    img {
      width: 100%;
    }

    @media ${ (props) => props.theme.breakpoints.devices.min.sm }, print {
      width: 100px;
    }
  }

  .title {
    margin-bottom: 10px;
  }

  .sub-title {
    color: ${ (props) => props.theme.colors['panel-inner-border'] };
    margin-bottom: 20px;
  }

  .image-title {
    margin-bottom: 20px;
  }

  .contact-item {
    margin-bottom: 10px;
  }

  .tooltip-container {
    margin-left: 10px;
  }

  // table styles
  table {
    width: 100%;
    border-spacing: 2px;
    border-collapse: separate;
    margin-bottom: 30px;
  }

  th,
  td {
    padding: 10px 15px 15px;
  }

  th {
    -webkit-print-color-adjust: exact;
    color-adjust: exact;
    background-color: ${ (props) => props.theme.colors['hintergrund-prio3'] };
    font-weight: 300;

    @media print {
      border: 1px solid ${ (props) => props.theme.colors['hintergrund-prio3'] };
    }
  }

  td {
    width: 50%;
    -webkit-print-color-adjust: exact;
    color-adjust: exact;
    background-color: ${ (props) => props.theme.colors['hintergrund-allgemein'] };

    @media print {
      border: 1px solid
        ${ (props) => props.theme.colors['hintergrund-allgemein'] };
    }
  }
`
